import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-input',
    template: `
    <mat-form-field
      class="demo-full-width"
      [formGroup]="group"
      appearance="outline"
      >
      <mat-label> {{ field.label }} </mat-label>
      <input
        matInput
        [formControlName]="field.key"
        [placeholder]="field.label"
        [type]="field.inputType"
        />
      <mat-hint align="start"
        ><em>{{ field.hint }}</em>
      </mat-hint>
      @for (validation of field.validations; track validation) {
        <ng-container
          ngProjectAs="mat-error"
          >
          @if (group.get(field.key).hasError(validation.name)) {
            <mat-error>{{
              validation.message
            }}</mat-error>
          }
        </ng-container>
      }
    </mat-form-field>
    `,
    // host: {'class': 'col-md-6'},
    styles: [],
    standalone: false
})
export class InputComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  // @HostBinding('class') rowClass = 'col-md-6';
  constructor() {}
  ngOnInit() {
    //  this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
  }
}
